module.exports = __webpack_public_path__ + "media/images/landkit/avatars/avatar-1-101011a98ca1209536053fc1d7375514.jpg";